import { createContext, useContext } from "react";
import type { SharedRun } from "@/api/types";

export interface SharedState {
  runId: string;
  info: SharedRun | undefined;
}

export const SharedContext = createContext<SharedState | null>(null);

export const useShared = () => useContext(SharedContext);

export interface RunLinks {
  shared: boolean;
  run: (runId: string) => string;
  report: (runId: string) => string;
  execution: (runId: string, executionId: string) => string;
}

export function runLinks(shared: boolean): RunLinks {
  const base = shared ? "/shared/runs" : "/runs";
  return {
    shared,
    run: (id) => `${base}/${id}`,
    report: (id) => `${base}/${id}/report`,
    execution: (id, executionId) => `${base}/${id}/executions/${executionId}`,
  };
}

export function useRunLinks(): RunLinks {
  return runLinks(useShared() !== null);
}
